import React, { useRef } from 'react';
import { ResultModal } from './v2/ResultModal.styles';
import RiskCardPrimBackoffice from '../Cards/RiskCardPrimBackoffice';
import RiskCard from '../Cards/RiskCard';
import { primaMergeQuoteTypes } from '../../../constants';

function ModalQuotesPrimaBackoffice({
  type, addingQuote, requestInfo, processingQuote, quotations, selectQuotation, riskQuotations,
}) {
  const closeButtonRef = useRef(null);

  const closeButton = () => {
    if (closeButtonRef.current) {
      closeButtonRef.current.click(); // Close the modal
    }
  };

  // This Prima guarantee type (e.g. protezione_rivalse) may have a matching
  // `quotations` key (e.g. rivalsa) with company_id 1001 (Nobis) alternatives.
  const mergeConfig = primaMergeQuoteTypes.find((m) => m.primaSlug === type.id);
  const nobisType = mergeConfig ? { id: mergeConfig.id, name: type.name } : null;
  const nobisQuotes = mergeConfig && Array.isArray(quotations?.[mergeConfig.id])
    ? quotations[mergeConfig.id].filter((q) => q.company_id === 1001)
    : [];

  // Always suffix with `_prima` — the plain `type.id` collides with the
  // generic ModalQuotes' `id={type.id}` (rendered for every entry in the
  // server-provided quoteTypes list), which sits earlier in the DOM and
  // would otherwise "win" the data-bs-target lookup, opening an empty modal.
  const createIdForModal = () => `${type.id}_prima`;

  return (
    <ResultModal className="modal fade" id={createIdForModal()} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">{type.name}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" id="buttonClose" ref={closeButtonRef} />
          </div>
          <div className="modal-body">
            {addingQuote === false && (
              <>
                <div className="row purchase-quote-eight-step">
                  {(processingQuote !== null && processingQuote.company_id === 2) ? (
                    <>
                      {processingQuote.quotation_data_prima.quotation_data_prima_guarantees.length > 0 && processingQuote.quotation_data_prima.quotation_data_prima_guarantees.filter((g) => g.slug === type.id).map((quote, key) => (
                        <RiskCardPrimBackoffice
                          quote={quote}
                          type={type}
                          key={key}
                          requestInfo={requestInfo}
                          processingQuote={processingQuote}
                          closeButton={closeButton}
                        />
                      ))}
                      {processingQuote.quotation_data_prima.quotation_data_prima_guarantees.filter((g) => g.slug === type.id).length === 0 && <h5 className="fw-bold">Nessuna Quotazione Trovata</h5>}
                    </>
                  )
                    : <h5 className="fw-bold">Nessuna Quotazione Trovata</h5>}

                  {(processingQuote !== null && processingQuote.quotation_data_prima.quotation_data_prima_guarantees.filter((g) => g.slug === type.id) === 0) && <h5 className="fw-bold">Nessuna Quotazione Trovata</h5>}
                </div>

                {nobisQuotes.length > 0 && (
                  <div className="row purchase-quote-eight-step mt-3">
                    {nobisQuotes.map((quote, index) => (
                      <div className="col-12 mb-2" key={quote.id ?? index}>
                        <RiskCard
                          quote={quote}
                          type={nobisType}
                          selectQuotation={(quoteId) => selectQuotation(quoteId, closeButton)}
                          requestInfo={requestInfo}
                          riskQuotes={riskQuotations}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}

          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-danger px-4" data-bs-dismiss="modal">Chiudi</button>
          </div>
        </div>
      </div>
    </ResultModal>
  );
}

export default ModalQuotesPrimaBackoffice;
